import * as d3 from 'd3';
import moment from 'moment/moment';
import Axis from './Axis.js';

export default class UnitsMonthAxis extends Axis {
  constructor(props) {
    super(props);

    this.axis = d3
      .axisBottom(this.xScale)
      .ticks(d3.timeMonth.every(1))
      .tickFormat(d3.timeFormat('%B'));
  }

  positionText() {
    const {
      chart,
      options: { width, monthCount, scaleType },
    } = this.props;

    if (scaleType === 'month') {
      chart
        .selectAll('.month .tick text')
        .attr('transform', `translate(${width / monthCount / 2}, 0)`);
    } else if (scaleType === 'quarter') {
      chart
        .selectAll('.month .tick text')
        .attr('transform', `translate(${width / monthCount / 2}, 18)`);
    } else {
      chart.selectAll('.month .tick text').attr('opacity', 0);
    }

    return this;
  }

  setCurrentMonth() {
    const {
      chart,
      options: { scaleType },
    } = this.props;

    if (scaleType === 'month') {
      chart.selectAll('.month .tick text').attr('class', (value) => {
        if (moment(value, 'YYYY-MM-DD').isSame(moment(), 'month')) {
          return 'current-month';
        }
      });
    }
    return this;
  }

  addMonthGrid() {
    const {
      chart,
      options: { height, scaleType },
    } = this.props;
    chart
      .selectAll('.month .tick')
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', `${scaleType === 'quarter' ? '3.3' : false}`)
      .attr('y2', height);

    return this;
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.month .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.month')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.positionText().addMonthGrid().removeDomainPath().setCurrentMonth();
  }

  build() {
    const { chart } = this.props;

    chart
      .append('g')
      .attr('class', 'axis month')
      .attr('transform', 'translate(0,0)')
      .call(this.axis);

    this.positionText().addMonthGrid().removeDomainPath().setCurrentMonth();
  }
}
